import e from"prop-types";import o from"../createBox.js";const p=o();"production"!==process.env.NODE_ENV&&(p.propTypes={children:e.node,component:e.elementType,sx:e.oneOfType([e.arrayOf(e.oneOfType([e.func,e.object,e.bool])),e.func,e.object])});var r=p;export{r as default};
//# sourceMappingURL=Box.js.map
